import { Injectable } from "@angular/core";
import { HttpService } from "@app/core/http/http.service";

import { AgentsMacroGroupView } from '@app/shared/views/AgentsMacroGroupView';

import { Observable } from "rxjs";

@Injectable()
export class MacroGroupsService {

  //En api se admiten ambos routes pero se utilizará solo el de customer cuando se envie el customerId
  private sApiCustomers = '/api/customer';
  private sApiGetMacroGroups = '/macro-groups';
  private sApiMacroGroupsUpload = '/macro-groups/upload';

	constructor(private http: HttpService) { }

  public uploadMacroGroups(customerId: number, content: string): Observable<string> {
    return this.http.post<string>(this.sApiCustomers + '/' + customerId + this.sApiMacroGroupsUpload, JSON.stringify(content));
  }

  public getAgentsMacroGroupsByCustomer(customerId: number): Observable<Array<AgentsMacroGroupView>>  {
    return this.http.get<Array<AgentsMacroGroupView>>(this.sApiCustomers + '/' + customerId + this.sApiGetMacroGroups);
  }
}
